import { Discount } from '@mui/icons-material';

import Chip from '@/components/ui/Chip/Chip';
import useFormatMessage from '@/hooks/useFormatMessage';

const SaleChip = () => {
  const formatMessage = useFormatMessage();

  return (
    <Chip color="success" uppercase gap={1}>
      <Discount sx={{ width: 18, height: 18 }} />
      {formatMessage('rental_price_sale')}
    </Chip>
  );
};

export default SaleChip;
